var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWeights(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.67225 10.0321L9.45371 5.50567C9.60629 5.45481 9.80973 5.45481 9.91145 5.50567L19.5437 11.0046L20.154 10.6994V11.4623C20.154 11.5132 20.1032 11.564 20.0523 11.6149L11.8131 16.3448C11.6605 16.3957 11.4571 16.3957 11.3045 16.3448L1.21451 10.5407C1.16365 10.5407 1.11279 10.4899 1.11279 10.439V9.67613H1.67225V10.0321Z",
    fill: "#D1D3D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.45373 4.80474C9.60631 4.75389 9.80975 4.75389 9.91146 4.80474L20.0523 10.5979C20.2049 10.6487 20.2049 10.8013 20.0523 10.903L11.8131 15.6329C11.6605 15.7347 11.4571 15.7347 11.3045 15.6329L1.21453 9.83981C1.06195 9.78895 1.06195 9.63638 1.21453 9.58552L9.45373 4.80474Z",
    fill: "#F3F3F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0859 10.8013L17.5601 11.6659C17.4075 11.7676 17.255 11.7676 17.1024 11.6659L15.068 10.4961C15.0171 10.4453 14.9663 10.3436 15.068 10.2927L16.5938 9.4281C16.7464 9.32638 16.8989 9.32638 17.0515 9.4281L19.0859 10.5979C19.1876 10.6487 19.1876 10.7504 19.0859 10.8013Z",
    fill: "url(#paint0_linear_103_23030)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.434 14.3174L11.9083 15.182C11.7557 15.2837 11.6031 15.2837 11.4505 15.182L9.41615 14.0123C9.36529 13.9614 9.31443 13.8597 9.41615 13.8088L10.9419 12.9442C11.0945 12.8425 11.2471 12.8425 11.3997 12.9442L13.434 14.114C13.5358 14.1648 13.5358 14.2666 13.434 14.3174Z",
    fill: "url(#paint1_linear_103_23030)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.95601 10.1109L4.43023 10.9755C4.27765 11.0772 4.12507 11.0772 3.97249 10.9755L1.93812 9.80571C1.88726 9.75485 1.8364 9.65313 1.93812 9.60227L3.4639 8.73767C3.61648 8.63595 3.76906 8.63595 3.92163 8.73767L5.95601 9.90743C6.05772 9.95829 6.05772 10.06 5.95601 10.1109Z",
    fill: "url(#paint2_linear_103_23030)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0317 6.68338L10.5059 7.54798C10.3533 7.6497 10.2008 7.6497 10.0482 7.54798L8.01381 6.37822C7.96295 6.32736 7.91209 6.22564 8.01381 6.17478L9.53958 5.31018C9.69216 5.20846 9.84474 5.20846 9.99732 5.31018L12.0317 6.47994C12.1334 6.5308 12.1334 6.63252 12.0317 6.68338Z",
    fill: "url(#paint3_linear_103_23030)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5596 7.01632L16.3232 9.20327L16.4249 9.15241C16.4758 9.10155 16.4758 9.05069 16.4249 8.99983L12.6104 6.76202C12.5087 6.71116 12.4579 6.71116 12.3561 6.76202L10.6778 7.72835C10.6269 7.77921 10.6269 7.83007 10.6778 7.88093L10.7287 7.93179L12.3053 7.01632C12.407 6.96546 12.5087 6.96546 12.5596 7.01632Z",
    fill: "#A7A9AC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7772 10.0883L16.3538 9.17285L12.5902 6.9859C12.4885 6.93504 12.4376 6.93504 12.3359 6.9859L10.7593 7.90137L14.5229 10.0883C14.6246 10.1392 14.7263 10.1392 14.7772 10.0883Z",
    fill: "#8B8E91"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7906 9.19952C13.8924 9.14866 13.9941 9.14866 14.0449 9.19952C14.0958 9.19952 14.0958 9.25038 14.0958 9.25038H14.0449C14.0449 9.25038 14.0449 9.19952 13.9941 9.19952C13.9432 9.19952 13.8924 9.19952 13.7906 9.19952C13.7398 9.25038 13.7398 9.30124 13.7906 9.3521H13.8415L13.8924 9.30124L13.8415 9.25038H13.8924L13.9941 9.30124L13.8924 9.3521C13.8415 9.3521 13.8415 9.3521 13.7906 9.30124C13.6889 9.3521 13.6889 9.25038 13.7906 9.19952Z",
    fill: "#F3F3F3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6889 9.04688L13.638 9.09773H13.8414H13.8923H13.638V9.25031H13.5871V9.14859L13.4854 9.19945H13.4346L13.6889 9.04688Z",
    fill: "#F3F3F3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8632 7.41504H12.7107L12.2529 7.66934V7.77105H12.4055L12.8632 7.4659V7.41504Z",
    fill: "#F3F3F3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4232 7.771H13.3215L12.8638 8.02529V8.07615H12.9655L13.4232 7.82186V7.771Z",
    fill: "#F3F3F3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8632 8.07617H12.7107L12.2529 8.38133V8.43219H12.4055L12.8632 8.17789V8.07617Z",
    fill: "#F3F3F3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2529 7.771V7.82186L12.7107 8.07615H12.8632V8.02529L12.4055 7.771H12.2529Z",
    fill: "#F3F3F3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8638 7.41504V7.4659L13.3215 7.77105H13.4232V7.66934L12.9655 7.41504H12.8638Z",
    fill: "#F3F3F3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6938 8.07617V8.17789L12.1516 8.43219H12.2533V8.38133L11.7956 8.07617H11.6938Z",
    fill: "#F3F3F3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6771 7.92358H13.5754L13.1177 8.17788V8.22874H13.2194L13.6771 7.97444V7.92358Z",
    fill: "#F3F3F3"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1181 8.22876H12.9655L12.5078 8.48306V8.58477H12.6095L13.1181 8.33048V8.22876Z",
    fill: "#F3F3F3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6771 8.58472H13.5754L13.1177 8.83901V8.88987H13.2194L13.6771 8.63558V8.58472Z",
    fill: "#F3F3F3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1177 8.22876V8.33048L13.5754 8.58477H13.6771V8.48306L13.2194 8.22876H13.1177Z",
    fill: "#F3F3F3"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6772 7.92358V7.97444L14.135 8.22874H14.2367V8.17788L13.779 7.92358H13.6772Z",
    fill: "#F3F3F3"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5078 8.58472V8.63558L12.9655 8.88987H13.1181V8.83901L12.6095 8.58472H12.5078Z",
    fill: "#F3F3F3"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0784 9.28442C14.1293 9.33528 14.1293 9.33528 14.1802 9.33528C14.1802 9.33528 14.231 9.38614 14.1802 9.38614C14.231 9.38614 14.231 9.38614 14.2819 9.38614C14.3327 9.38614 14.3327 9.437 14.2819 9.437L14.1802 9.48786H14.1293L14.231 9.437C14.2819 9.437 14.2819 9.38614 14.231 9.38614H14.1802L14.0784 9.437H14.0276L14.1293 9.38614C14.1802 9.33528 14.1802 9.33528 14.0784 9.28442C14.1293 9.28442 14.1293 9.28442 14.0784 9.28442L13.9259 9.38614H13.875L14.0784 9.28442Z",
    fill: "#87878C"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1803 9.53873H14.2311H14.282V9.48787C14.3328 9.48787 14.3837 9.48787 14.3837 9.48787L14.4345 9.53873H14.3837C14.3837 9.53873 14.3837 9.53873 14.3837 9.58959C14.3328 9.58959 14.282 9.58959 14.282 9.58959C14.282 9.58959 14.282 9.58959 14.2311 9.58959C14.2311 9.58959 14.2311 9.58959 14.2311 9.64045H14.282C14.3328 9.64045 14.3328 9.69131 14.282 9.69131C14.2311 9.69131 14.1803 9.69131 14.1294 9.69131C14.1294 9.58959 14.1294 9.53873 14.1803 9.53873ZM14.282 9.58959C14.3328 9.58959 14.282 9.58959 14.282 9.58959C14.2311 9.53873 14.2311 9.53873 14.2311 9.53873H14.1803V9.58959C14.2311 9.58959 14.282 9.58959 14.282 9.58959ZM14.4345 9.48787C14.4345 9.43701 14.3837 9.43701 14.3837 9.43701V9.48787C14.3328 9.53873 14.3837 9.53873 14.4345 9.48787Z",
    fill: "#87878C"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6885 9.53882L14.3325 9.6914L14.6885 9.53882Z",
    fill: "#87878C"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5871 9.64044C14.638 9.58958 14.6888 9.58958 14.7397 9.64044C14.7397 9.64044 14.7397 9.64044 14.7906 9.6913H14.8414L14.8923 9.64044H14.9431L14.6888 9.79302H14.638C14.5363 9.6913 14.5363 9.64044 14.5871 9.64044ZM14.638 9.74216L14.7397 9.6913C14.7397 9.6913 14.7397 9.6913 14.7397 9.64044C14.6888 9.64044 14.6888 9.64044 14.638 9.64044C14.5871 9.64044 14.5871 9.6913 14.638 9.6913C14.5871 9.74216 14.638 9.74216 14.638 9.74216Z",
    fill: "#87878C"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7398 9.79312L14.9432 9.69141H14.9941L14.7398 9.79312C14.6889 9.79312 14.6889 9.79312 14.7398 9.79312Z",
    fill: "#87878C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_103_23030",
    x1: 17.9256,
    y1: 8.6614,
    x2: 17.1467,
    y2: 12.5562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7A9AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_103_23030",
    x1: 12.2738,
    y1: 12.1775,
    x2: 11.4948,
    y2: 16.0723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7A9AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_103_23030",
    x1: 4.79574,
    y1: 7.97097,
    x2: 4.01678,
    y2: 11.8658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7A9AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_103_23030",
    x1: 10.8714,
    y1: 4.54348,
    x2: 10.0925,
    y2: 8.43831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7A9AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeights);
export default __webpack_public_path__ + "static/media/weights.1afa6decac16958e5d8b97aa26ede68d.svg";
export { ForwardRef as ReactComponent };